import apiV1, { getApiPrefix } from "@common/lib/api";
import { type I18n } from "@common/lib/i18n";
import Network from "@common/modules/network/types";

const createApi = (i18n: I18n, isHost: boolean) => {
  const apiPrefix = getApiPrefix(isHost);

  return {
    getGenealogyCycleAggregates: (id: number, cycleEndDate: string | null): Promise<Network.GenealogyCycleAggregates> =>
      apiV1.get(i18n, `${apiPrefix}/mlm/genealogy/${id}/cycleAggregates`, {
        cycleEndDate,
        startLevel: 0,
        endLevel: 0
      }),
    getAggregatedIncomeByUser: (
      data: Network.Api.GetAggregatedUserIncomeRequest
    ): Promise<Network.Api.AggregatedUserIncome[]> =>
      apiV1.get(i18n, `${apiPrefix}/mlm/aggregate/incomeTotalByUser`, data),
    getGenealogyDownline: (data: Network.Api.GetGenealogyDownlineRequest): Promise<Network.Api.GenealogyItem[]> =>
      apiV1.get(i18n, `${apiPrefix}/data/genealogy/downline`, data),
    getGenealogyDetail: (id: number, cycleEndDate: string): Promise<Network.Api.GenealogyDetail> =>
      apiV1.get(i18n, `${apiPrefix}/mlm/genealogy/${id}`, { cycleEndDate })
  };
};

export const getApi = (i18n: I18n, isHost?: boolean) => createApi(i18n, isHost ?? false);
